const styles = {
  deliveryDate: {
    p: 3,
    color: 'info.darkest',
    backgroundColor: 'info.light',
    width: 243,
  },
  emptyDeliveryDate: {
    p: 3,
    color: 'yellow.darkest',
    backgroundColor: 'yellow.lighter',
    width: 243,
  },
  hasError: {
    color: 'error.dark',
    backgroundColor: 'error.light',
  },
  infoText: {
    mb: 1,
  },
  note: {
    mt: 2,
    display: 'flex',
    columnGap: 1.5,
  },
  button: {
    fontSize: '.75rem',
    padding: '.25rem .5rem',
    fontFamily: ['Arial', 'sans-serif'].join(','),
  },
}

export default styles
